import React from 'react';
import { safeHTML } from '../../../../../utils/safeHTML';
import { Swiper, SwiperSlide } from 'swiper/react';
import Achievement from '../../../../features/achiev';
import { defaultStore, useTranslation } from '../../../../../translations';
import content from '../../constants/content';
import { ACHIEVEMENTS, getIsAvailableEvent } from '../../../../../constants/events';
import useGetUserAchievementsWithMaxGrade from '../../../../../hooks/shared/achievements/useGetUserAchievementsWithMaxGrade';

const {
  achievements: { title, text },
} = content;

export default function Achievements() {
  const getUserAchievements = useGetUserAchievementsWithMaxGrade();
  const userAchievements = getUserAchievements();
  const { t } = useTranslation();

  return (
    !!userAchievements?.length &&
    getIsAvailableEvent(defaultStore, ACHIEVEMENTS) && (
      <div className={'friends-achievements'}>
        <h2 className={'friends-achievements__title'}>{safeHTML(t(title))}</h2>
        <p className={'friends-achievements__text'}>{safeHTML(t(text))}</p>
        <div className={'friends-achievements__list'}>
          <Swiper watchOverflow={'auto'} slidesPerView={'auto'}>
            {userAchievements?.map(({ quest_end_at, ...otherProps }) => (
              <SwiperSlide key={otherProps.system_name}>
                <Achievement {...otherProps} type={'swiper'} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    )
  );
}
